// Fires event425 and sets vzdl.event.testData to "yes" only when test data is detected.

import { eventDispatcher } from '../components/common/Tagging';

export const TEST_FNAME = 'test';
export const TEST_LNAME = 'tester';
export const TEST_SSN = '123456789';

export const isTestData = (firstName = '', lastName = '', ssn = '') =>
  (firstName?.toLowerCase()?.trim() === TEST_FNAME && lastName?.toLowerCase()?.trim() === TEST_LNAME) ||
  ssn?.replace(/\D/g, '') === TEST_SSN;

export const triggerEvent425 = (firstName = '', lastName = '', ssn = '') => {
  if (typeof window === 'undefined') return;

  const testDataFlag = isTestData(firstName, lastName, ssn);

  if (!testDataFlag) return;

  if (window.vzdl) {
    if (!window.vzdl.event) {
      window.vzdl.event = {};
    }
    window.vzdl.event.testData = 'yes';
  }

  eventDispatcher('sendData', {
    name: 'event425',
    events: 'event425',
  });
};

/**
 * Shared selector to retrieve fwaTriggerEvent425FFlag from Redux state.
 * Centralizes flag retrieval logic to avoid duplication across containers.
 */
export const selectFwaTriggerEvent425FFlag = (state) =>
  state.cartDetails?.cartDetailsJson?.featureFlags?.fwaTriggerEvent425FFlag ||
  state.checkout?.getCheckoutResponse?.data?.featureFlags?.fwaTriggerEvent425FFlag ||
  false;
